import {
  DataSourceType,
  PivotDimensionBucketingType,
  PivotValueAggregationType,
  SortType,
  SubscriptionPlanType,
} from "@coeff/api";

export * from "./free-domains";
export * from "./data-source";
export * from "./assets";
export * from "./filters";

export const FILE_BASED_GOOGLE_CONNECTORS: DataSourceType[] = [
  DataSourceType.GoogleDrive,
  DataSourceType.Csv,
  DataSourceType.GoogleSheets,
];

export const GPT_SQL_SUPPORTED_DATASOURCES: DataSourceType[] = [
  DataSourceType.Mysql,
  DataSourceType.Postgres,
  DataSourceType.AuroraPostgres,
  DataSourceType.AuroraMysql,
  DataSourceType.CloudSqlPostgres,
  DataSourceType.CloudSqlMysql,
  DataSourceType.Supabase,
  DataSourceType.Neon,
  DataSourceType.Timescaledb,
  DataSourceType.AzurePostgres,
  DataSourceType.AzureMysql,
  DataSourceType.Clickhouse,
  DataSourceType.Mssql,
  DataSourceType.AzureSql,
  DataSourceType.Snowflake,
  DataSourceType.Databricks,
  DataSourceType.Motherduck,
];

export const CONFIG_DRIVEN_AI_DATA_SOURCE_TYPES: Array<DataSourceType> = [
  DataSourceType.ChargebeeAi,
  DataSourceType.StripeAi,
  DataSourceType.OutreachAi,
  DataSourceType.ClickupAi,
  DataSourceType.JiraAi,
  DataSourceType.SquareAi,
  DataSourceType.ExpensifyAi,
  DataSourceType.TwilioAi,
  DataSourceType.SendgridAi,

  DataSourceType.KitAi,
  DataSourceType.InsightlyAi,
  DataSourceType.FreshsalesAi,
  DataSourceType.CloseAi,
  DataSourceType.XeroAi,
  DataSourceType.ModeAi,
  DataSourceType.MondayAi,
  DataSourceType.MixpanelAi,
  DataSourceType.ClockifyAi,
  DataSourceType.KobotoolboxAi,
  DataSourceType.TogglTrackAi,
  DataSourceType.SmartsuiteAi,
  DataSourceType.OdooAi,
  DataSourceType.LinearAi,
  DataSourceType.KlaviyoAi,
  DataSourceType.RazorpayAi,
  DataSourceType.PaymoAi,
  DataSourceType.ActiveCampaignAi,
  DataSourceType.WordpressAi,
  DataSourceType.WooCommerceAi,
  DataSourceType.SmartleadAi,
  DataSourceType.ShiprocketAi,
  DataSourceType.RipplingAi,
  DataSourceType.HarvestAi,
  DataSourceType.CalendlyAi,
  DataSourceType.ZohobooksAi,
  DataSourceType.ZohoCrmAi,
  DataSourceType.BiginAi,
  DataSourceType.ApolloAi,
  DataSourceType.FreshdeskAi,
  DataSourceType.GreenhouseAi,
  DataSourceType.TrelloAi,
  DataSourceType.JotformAi,
  DataSourceType.CodaAi,
  DataSourceType.TypeformAi,
  DataSourceType.PodioAi,
  DataSourceType.SmartsheetAi,
  DataSourceType.BasecampAi,
  DataSourceType.MetabaseAi,
  DataSourceType.TeamworkAi,
  DataSourceType.CatsAtsAi,
  DataSourceType.NutshellAi,
  DataSourceType.PipelinerAi,
  DataSourceType.SalesflareAi,
  DataSourceType.VtigerCrmAi,
  DataSourceType.FreshserviceAi,
  DataSourceType.HiveAi,
  DataSourceType.AircallAi,
  DataSourceType.NimbleCrmAi,
  DataSourceType.DripAi,
  DataSourceType.PaddleAi,
  DataSourceType.AgileCrmAi,
  DataSourceType.CheckoutAi,
  DataSourceType.CapsuleAi,
  DataSourceType.BitbucketAi,
  DataSourceType.GitlabAi,
  DataSourceType.HelpscoutAi,
  DataSourceType.FrontAi,
  DataSourceType.WrikeAi,
  DataSourceType.BamboohrAi,
  DataSourceType.DeelAi,
  DataSourceType.ConfluenceAi,
  DataSourceType.TeamleaderAi,
  DataSourceType.MiroAi,
  DataSourceType.OmnisendAi,
  DataSourceType.AttioAi,
  DataSourceType.CreatioAi,
  DataSourceType.FreeagentAi,
  DataSourceType.MoneybirdAi,
  DataSourceType.AcceloAi,
  DataSourceType.ApplicantstackAi,
  DataSourceType.AlowareAi,
  DataSourceType.StackbyAi,
  DataSourceType.FloatAi,
  DataSourceType.ClickhouseAi,
  DataSourceType.AppsflyerAi,
  DataSourceType.MariadbAi,
  DataSourceType.LaunchdarklyAi,
  DataSourceType.PosthogAi,
  DataSourceType.DovetailAi,
  DataSourceType.ShipstationAi,
  DataSourceType.MindbodyAi,
  DataSourceType.GrowwAi,
  DataSourceType.AmazonSellerCentralAi,
  DataSourceType.AirwallexAi,
  DataSourceType.StatsigAi,
  DataSourceType.ModernTreasuryAi,
  DataSourceType.RudderstackAi,
  DataSourceType.BrightDataAi,
  DataSourceType.VwoAi,
  DataSourceType.PartnerizeAi,
  DataSourceType.RilletAi,
  DataSourceType.TrolleyAi,
  DataSourceType.ScalefusionAi,
  DataSourceType.BaremetricsAi,
  DataSourceType.TodoistAi,
  DataSourceType.WorkableAi,
  DataSourceType.PlausibleAi,
  DataSourceType.ApifyAi,
  DataSourceType.DatascopeAi,
  DataSourceType.GorgiasAi,
  DataSourceType.EverhourAi,
  DataSourceType.ExchangeratesAi,
  DataSourceType.FastbillAi,
  DataSourceType.GlassfrogAi,
  DataSourceType.ResourceFlowHubplannerAi,
  DataSourceType.KatanaAi,
  DataSourceType.MyhoursAi,
  DataSourceType.FisRailzAi,
  DataSourceType.TellentHrisAi,
  DataSourceType.SimfinAi,
  DataSourceType.SmartwaiverAi,
  DataSourceType.LokaliseAi,
  DataSourceType.MailerliteAi,
  DataSourceType.MailersendAi,
  DataSourceType.OnesignalAi,
  DataSourceType.PostmarkAi,
  DataSourceType.ShortIoAi,
  DataSourceType.YotpoAi,
  DataSourceType.ChartmogulAi,
  DataSourceType.ConfigcatAi,
  DataSourceType.PingdomAi,
  DataSourceType.RetentlyAi,
  DataSourceType.CoinmarketcapAi,
  DataSourceType.SoftrIoAi,
  DataSourceType.EmailoctopusAi,
  DataSourceType.GridlyAi,
  DataSourceType.MixmaxAi,
  DataSourceType.ReplyIoAi,
  DataSourceType.LessAnnoyingCrmAi,
  DataSourceType.SnovIoAi,
  DataSourceType.OnepagecrmAi,
  DataSourceType.LemlistAi,
];

export const CONFIG_DRIVEN_AI_OAUTH_DATA_SOURCE_TYPES: Array<DataSourceType> = [
  DataSourceType.OutreachAi,
  DataSourceType.JiraAi,
  DataSourceType.SquareAi,
  DataSourceType.XeroAi,
  DataSourceType.HarvestAi,
  DataSourceType.CalendlyAi,
  DataSourceType.ZohobooksAi,
  DataSourceType.ZohoCrmAi,
  DataSourceType.BiginAi,
  DataSourceType.TypeformAi,
  DataSourceType.PodioAi,
  DataSourceType.SmartsheetAi,
  DataSourceType.BasecampAi,
  DataSourceType.CapsuleAi,
  DataSourceType.BitbucketAi,
  DataSourceType.GitlabAi,
  DataSourceType.HelpscoutAi,
  DataSourceType.FrontAi,
  DataSourceType.WrikeAi,
  DataSourceType.BamboohrAi,
  DataSourceType.DeelAi,
  DataSourceType.ConfluenceAi,
  DataSourceType.TeamleaderAi,
  DataSourceType.MiroAi,
  DataSourceType.OmnisendAi,
  DataSourceType.AttioAi,
  DataSourceType.CreatioAi,
  DataSourceType.FreeagentAi,
  DataSourceType.MoneybirdAi,
  DataSourceType.AcceloAi,
];

export const PPRESS_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Jira,
  DataSourceType.InstagramInsights,
  DataSourceType.Stripe,
  DataSourceType.Zendesk,
  DataSourceType.Quickbooks,
  DataSourceType.Shopify,
  DataSourceType.Airtable,
  DataSourceType.Mailchimp,
  DataSourceType.Pipedrive,
  DataSourceType.OneDrive,
  DataSourceType.SharepointLists,
  DataSourceType.Outreach,
  DataSourceType.GoogleAds,
  DataSourceType.GoogleAnalytics4,
  DataSourceType.FacebookAds,
  DataSourceType.GoogleSearchConsole,
  DataSourceType.Chargebee,
  DataSourceType.Notion,
  DataSourceType.Linkedin,
  DataSourceType.LinkedinAds,
  DataSourceType.FacebookInsights,
  DataSourceType.YoutubeAnalytics,
  DataSourceType.LinkedinPages,
  DataSourceType.CustomApi,
  DataSourceType.AnyApiAgent,
  DataSourceType.BrowserAgent,
  DataSourceType.MicrosoftAds,
  DataSourceType.Netsuite,
  DataSourceType.NetsuiteCrx,
  DataSourceType.Xero,
  DataSourceType.Klaviyo,
  DataSourceType.Asana,
  DataSourceType.Razorpay,
  DataSourceType.Clickup,
  DataSourceType.Typeform,
  DataSourceType.Harvest,
  DataSourceType.Freshdesk,
  DataSourceType.Paymo,
  DataSourceType.GoogleCalendar,
  DataSourceType.AmazonSellerCentral,
  DataSourceType.Trello,
  DataSourceType.Gong,
  DataSourceType.Calendly,
  DataSourceType.Smartsheet,
  DataSourceType.RedditAds,
  DataSourceType.Surveymonkey,
  DataSourceType.QuoraAds,
  DataSourceType.Podio,
  DataSourceType.Greenhouse,
  DataSourceType.Gusto,
  DataSourceType.Intercom,
  DataSourceType.Etsy,
  DataSourceType.PinterestAds,
  DataSourceType.ActiveCampaign,
  DataSourceType.Basecamp,
  DataSourceType.Jotform,
  DataSourceType.Zohobooks,
  DataSourceType.Coda,
  DataSourceType.Square,
  DataSourceType.Zoom,
  DataSourceType.Webflow,
  DataSourceType.ZohoCrm,
  DataSourceType.Bigin,
  DataSourceType.Lever,
  DataSourceType.Salesloft,
  DataSourceType.Wordpress,
  DataSourceType.WooCommerce,
  DataSourceType.Bigcommerce,
  DataSourceType.Smartlead,
  DataSourceType.Affinity,
  DataSourceType.Looker,
  DataSourceType.NetflixQuiver,
  DataSourceType.Amplitude,
  DataSourceType.Shiprocket,
  DataSourceType.Rippling,
  DataSourceType.Apollo,
  DataSourceType.AwsBilling,
  DataSourceType.Gmail,
  DataSourceType.Sage,
  DataSourceType.GoogleClassroom,
  DataSourceType.Campfire,
  DataSourceType.Rillet,
  ...CONFIG_DRIVEN_AI_DATA_SOURCE_TYPES,
];

export const PPRESS_REAUTH_DATASOURCES: Array<DataSourceType> = [
  ...PPRESS_DATASOURCES,
  DataSourceType.Salesforce,
  DataSourceType.Hubspot,
  DataSourceType.Snowflake,
  DataSourceType.Looker,
];

/**
 * Wire-compatible families, mirroring spec.POSTGRES_WIRE_DATA_SOURCE_TYPES and friends on the
 * backend. Anything in a family runs the engine's driver and dialect, so UI capability lists
 * should key off the family rather than naming engines one at a time -- several lists here used
 * to hardcode `["mysql", "postgres", "mssql", ...]` and no variant was ever added to them, which
 * silently withheld features (SSH tunnelling among them) from every managed service.
 */
// Keep in sync with POSTGRES_WIRE_DATA_SOURCE_TYPES in spec.py
export const POSTGRES_WIRE_DATA_SOURCE_TYPES: ReadonlySet<DataSourceType> = new Set([
  DataSourceType.AuroraPostgres,
  DataSourceType.AzurePostgres,
  DataSourceType.CloudSqlPostgres,
  DataSourceType.Neon,
  DataSourceType.Postgres,
  DataSourceType.Supabase,
  DataSourceType.Timescaledb,
]);

// Keep in sync with MYSQL_WIRE_DATA_SOURCE_TYPES in spec.py
export const MYSQL_WIRE_DATA_SOURCE_TYPES: ReadonlySet<DataSourceType> = new Set([
  DataSourceType.AuroraMysql,
  DataSourceType.AzureMysql,
  DataSourceType.CloudSqlMysql,
  DataSourceType.Mysql,
]);

// Keep in sync with MSSQL_WIRE_DATA_SOURCE_TYPES in spec.py
export const MSSQL_WIRE_DATA_SOURCE_TYPES: ReadonlySet<DataSourceType> = new Set([
  DataSourceType.AzureSql,
  DataSourceType.Mssql,
]);

export const SQL_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Mysql,
  DataSourceType.Postgres,
  DataSourceType.AuroraPostgres,
  DataSourceType.AuroraMysql,
  DataSourceType.CloudSqlPostgres,
  DataSourceType.CloudSqlMysql,
  DataSourceType.Supabase,
  DataSourceType.Neon,
  DataSourceType.Timescaledb,
  DataSourceType.AzurePostgres,
  DataSourceType.AzureMysql,
  DataSourceType.Clickhouse,
  DataSourceType.Redshift,
  DataSourceType.Snowflake,
  DataSourceType.Mssql,
  DataSourceType.AzureSql,
  DataSourceType.Bigquery,
  DataSourceType.CloudTable,
  DataSourceType.Databricks,
  DataSourceType.ArrowFlightSql,
  DataSourceType.Motherduck,
];

export const CUSTOM_API_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.CustomApi,
  DataSourceType.Xero,
  DataSourceType.Asana,
  DataSourceType.Klaviyo,
  DataSourceType.Razorpay,
  DataSourceType.Clickup,
  DataSourceType.Typeform,
  DataSourceType.Harvest,
  DataSourceType.Freshdesk,
  DataSourceType.Paymo,
  DataSourceType.GoogleCalendar,
  DataSourceType.AmazonSellerCentral,
  DataSourceType.Trello,
  DataSourceType.Gong,
  DataSourceType.Calendly,
  DataSourceType.Smartsheet,
  DataSourceType.RedditAds,
  DataSourceType.Surveymonkey,
  DataSourceType.QuoraAds,
  DataSourceType.Podio,
  DataSourceType.Greenhouse,
  DataSourceType.Gusto,
  DataSourceType.Intercom,
  DataSourceType.Etsy,
  DataSourceType.PinterestAds,
  DataSourceType.ActiveCampaign,
  DataSourceType.Basecamp,
  DataSourceType.Jotform,
  DataSourceType.Zohobooks,
  DataSourceType.Coda,
  DataSourceType.Square,
  DataSourceType.Zoom,
  DataSourceType.Webflow,
  DataSourceType.ZohoCrm,
  DataSourceType.Bigin,
  DataSourceType.Lever,
  DataSourceType.Salesloft,
  DataSourceType.Wordpress,
  DataSourceType.WooCommerce,
  DataSourceType.Bigcommerce,
  DataSourceType.Smartlead,
  DataSourceType.Affinity,
  DataSourceType.Shiprocket,
  DataSourceType.Rippling,
  DataSourceType.Apollo,
  DataSourceType.GoogleClassroom,
];

export const SQL_FLOW_REUSE_DATASOURCES: Array<DataSourceType> = [DataSourceType.Mongodb];

export const WRITEBACK_SUPPORTED_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Salesforce,
  DataSourceType.Mysql,
  DataSourceType.Postgres,
  DataSourceType.Hubspot,
  DataSourceType.Snowflake,
  DataSourceType.Netsuite,
];

export const NESTED_FILTERS_SUPPORTED_DATA_SOURCES: ReadonlySet<DataSourceType> = new Set([
  DataSourceType.Hubspot,
  DataSourceType.Postgres,
  DataSourceType.Motherduck,
  DataSourceType.Mysql,
  DataSourceType.AuroraPostgres,
  DataSourceType.AuroraMysql,
  DataSourceType.CloudSqlPostgres,
  DataSourceType.CloudSqlMysql,
  DataSourceType.Supabase,
  DataSourceType.Neon,
  DataSourceType.Timescaledb,
  DataSourceType.AzurePostgres,
  DataSourceType.AzureMysql,
  DataSourceType.Clickhouse,
  DataSourceType.Redshift,
  DataSourceType.Mssql,
  DataSourceType.AzureSql,
  DataSourceType.Bigquery,
  DataSourceType.Snowflake,
  DataSourceType.Salesforce,
  DataSourceType.Databricks,
  DataSourceType.Looker,
  // The Quiver connector reads `filter_clause` server-side (`_flatten_filter_clause`),
  // so it has to be on this list: without it `getFilterCount` counts the legacy
  // `filters` array instead, the sidepane's Filters well stays empty, and
  // `cleanIllFormedFilters` wipes the clause the user just built.
  DataSourceType.NetflixQuiver,
]);

// Connectors that push a pivot into their own query, so a pivot with values but no rows or
// columns comes back already aggregated (one row, one column per value). Only these may save
// that shape. Mirrors `_PIVOT_PUSHDOWN_DATA_SOURCES` in
// coeff/server/controllers/data_import_controller.py; keep the two in step.
export const PIVOT_PUSHDOWN_DATASOURCES: Array<DataSourceType> = [DataSourceType.NetflixQuiver];

// Connectors whose source error the "Show full error" dialog renders pre-wrapped in a
// scrolling well. Quiver's structured errors carry the generated SQL at the tail, which is
// the part Netflix debugs from; the backend sends it uncapped too (`_quiver_source_error`
// in coeff/server/lib/ppress/netflix_quiver.py). The error card itself clamps as usual.
export const UNTRUNCATED_SOURCE_ERROR_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.NetflixQuiver,
];

export const WRITEBACK_COMING_SOON_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Snowflake,
  DataSourceType.Quickbooks,
];

const DATA_IMPORT_RECIPES_DISABLED_PPRESS_DATA_SOURCE_TYPES: Set<DataSourceType> = new Set([
  DataSourceType.Amplitude,
  DataSourceType.Gmail,
  DataSourceType.Linkedin,
]);

export const DATA_IMPORT_RECIPES_SUPPORTED_DATA_SOURCE_TYPES: Array<DataSourceType> = [
  DataSourceType.Hubspot,
  DataSourceType.Salesforce,
  DataSourceType.GoogleAnalytics,
  ...PPRESS_DATASOURCES.filter(
    dataSource => !DATA_IMPORT_RECIPES_DISABLED_PPRESS_DATA_SOURCE_TYPES.has(dataSource)
  ),
  // All SQL datasources except Cloud Tables
  ...([
    DataSourceType.Mysql,
    DataSourceType.Postgres,
    DataSourceType.AuroraPostgres,
    DataSourceType.AuroraMysql,
    DataSourceType.CloudSqlPostgres,
    DataSourceType.CloudSqlMysql,
    DataSourceType.Supabase,
    DataSourceType.Neon,
    DataSourceType.Timescaledb,
    DataSourceType.AzurePostgres,
    DataSourceType.AzureMysql,
    DataSourceType.Clickhouse,
    DataSourceType.Redshift,
    DataSourceType.Snowflake,
    DataSourceType.Mssql,
    DataSourceType.AzureSql,
    DataSourceType.Bigquery,
    DataSourceType.Mongodb,
    DataSourceType.Databricks,
    DataSourceType.Motherduck,
  ] as Array<DataSourceType>),
];

export const SINGLE_MODE_PICKLIST_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.MicrosoftAds,
  DataSourceType.YoutubeAnalytics,
  // Every Rillet picklist filter (status, subsidiary_id, country) maps to a
  // query param that takes exactly one value, so a tags-mode select would let
  // users enter values that are silently dropped.
  DataSourceType.Rillet,
];

// Data sources whose filters are resolved into one query param per field, so a
// second filter on the same field cannot apply — the last one would silently
// win. The "add filter" list hides a field once it is used, EXCEPT date fields,
// where a lower and an upper bound are separate params and pair up legitimately.
export const SINGLE_FILTER_PER_COLUMN_DATASOURCES: Array<DataSourceType> = [DataSourceType.Rillet];

export const OAUTH_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Bigquery,
  DataSourceType.GoogleDrive,
  DataSourceType.OneDrive,
  DataSourceType.Amplitude,
  DataSourceType.Box,
  DataSourceType.Egnyte,
  DataSourceType.SharepointLists,
];

export const PPRESS_API_KEY_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Chargebee,
  DataSourceType.Klaviyo,
  DataSourceType.Razorpay,
  DataSourceType.Freshdesk,
  DataSourceType.Paymo,
  DataSourceType.Trello,
  DataSourceType.Greenhouse,
  DataSourceType.ActiveCampaign,
  DataSourceType.Coda,
  DataSourceType.Jotform,
  DataSourceType.Wordpress,
  DataSourceType.WooCommerce,
  DataSourceType.Smartlead,
  DataSourceType.Affinity,
  DataSourceType.Shiprocket,
  DataSourceType.Rippling,
  DataSourceType.Apollo,
  DataSourceType.AwsBilling,
  DataSourceType.Sage,
];

export const MULTIPLE_OAUTH_DATASOURCES: ReadonlySet<string> = new Set([
  DataSourceType.Quickbooks,
  DataSourceType.LinkedinAds,
  DataSourceType.LinkedinPages,
  DataSourceType.YoutubeAnalytics,
  DataSourceType.Pipedrive,
  DataSourceType.Airtable,
  DataSourceType.Stripe,
  DataSourceType.GoogleSearchConsole,
  DataSourceType.FacebookInsights,
  DataSourceType.GoogleAds,
  DataSourceType.Mailchimp,
  DataSourceType.Outreach,
  DataSourceType.FacebookAds,
  DataSourceType.GoogleAnalytics4,
  DataSourceType.Hubspot,
  DataSourceType.Salesforce,
  DataSourceType.InstagramInsights,
  DataSourceType.Jira,
  DataSourceType.GoogleAnalytics,
  DataSourceType.Notion,
  DataSourceType.Zendesk,
  DataSourceType.Shopify,
  DataSourceType.MicrosoftAds,
  DataSourceType.Netsuite,
  DataSourceType.Xero,
  DataSourceType.Asana,
  DataSourceType.Clickup,
  DataSourceType.Typeform,
  DataSourceType.GoogleCalendar,
  DataSourceType.Gmail,
  DataSourceType.Gong,
  DataSourceType.Calendly,
  DataSourceType.Smartsheet,
  DataSourceType.RedditAds,
  DataSourceType.Surveymonkey,
  DataSourceType.QuoraAds,
  DataSourceType.Harvest,
  DataSourceType.Podio,
  DataSourceType.Gusto,
  DataSourceType.Intercom,
  DataSourceType.Etsy,
  DataSourceType.PinterestAds,
  DataSourceType.Basecamp,
  DataSourceType.Zohobooks,
  DataSourceType.Square,
  DataSourceType.Zoom,
  DataSourceType.Webflow,
  DataSourceType.ZohoCrm,
  DataSourceType.Bigin,
  DataSourceType.Lever,
  DataSourceType.Salesloft,
  DataSourceType.Bigcommerce,
  DataSourceType.GoogleClassroom,
  DataSourceType.NetflixQuiver,
]);

export const ALWAYS_CHANGE_SOURCE_ENABLED_DATASOURCES: ReadonlySet<string> = new Set([
  DataSourceType.Looker,
  DataSourceType.Tableau,
  DataSourceType.NetsuiteCrx,
]);

export const PHASE_TWO_MULTIPLE_OAUTH_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Jira,
  DataSourceType.GoogleAnalytics,
  DataSourceType.Airtable,
  DataSourceType.Pipedrive,
  DataSourceType.Stripe,
  DataSourceType.Mailchimp,
  DataSourceType.Notion,
  DataSourceType.Zendesk,
  DataSourceType.Shopify,
];

export const DATA_SOURCES_IN_BETA: Array<DataSourceType> = [
  DataSourceType.Amplitude,
  DataSourceType.Clickhouse,
];

export const WRITEBACK_DATA_SOURCES_IN_BETA: DataSourceType[] = [DataSourceType.Netsuite];

export const PREMIUM_DATA_SOURCES: DataSourceType[] = [
  DataSourceType.Snowflake,
  DataSourceType.Looker,
  DataSourceType.Tableau,
  DataSourceType.Mssql,
  DataSourceType.AzureSql,
  DataSourceType.Netsuite,
  DataSourceType.Bigquery,
  DataSourceType.Databricks,
  DataSourceType.Sage,
  DataSourceType.NetsuiteCrx,
  DataSourceType.Rillet,
];

export const SHAREABLE_PPRESS_DATA_SOURCES: Array<DataSourceType> = [
  DataSourceType.Quickbooks,
  DataSourceType.LinkedinAds,
  DataSourceType.LinkedinPages,
  DataSourceType.YoutubeAnalytics,
  DataSourceType.GoogleSearchConsole,
  DataSourceType.FacebookInsights,
  DataSourceType.GoogleAds,
  DataSourceType.Outreach,
  DataSourceType.FacebookAds,
  DataSourceType.Mailchimp,
  DataSourceType.GoogleAnalytics4,
  DataSourceType.Chargebee,
  DataSourceType.InstagramInsights,
  DataSourceType.GoogleAnalytics,
  DataSourceType.Jira,
  DataSourceType.Stripe,
  DataSourceType.Notion,
  DataSourceType.Zendesk,
  DataSourceType.Pipedrive,
  DataSourceType.Airtable,
  DataSourceType.Shopify,
  DataSourceType.Bigquery,
  DataSourceType.MicrosoftAds,
  DataSourceType.Netsuite,
  DataSourceType.Hubspot,
  DataSourceType.Salesforce,
  DataSourceType.Xero,
  DataSourceType.Klaviyo,
  DataSourceType.Asana,
  DataSourceType.Razorpay,
  DataSourceType.Clickup,
  DataSourceType.Typeform,
  DataSourceType.Harvest,
  DataSourceType.Freshdesk,
  DataSourceType.Paymo,
  DataSourceType.GoogleCalendar,
  DataSourceType.AmazonSellerCentral,
  DataSourceType.Trello,
  DataSourceType.Gong,
  DataSourceType.Calendly,
  DataSourceType.Campfire,
  DataSourceType.Rillet,
  // Special case
  DataSourceType.Looker,
  DataSourceType.Snowflake,
  DataSourceType.Smartsheet,
  DataSourceType.RedditAds,
  DataSourceType.Surveymonkey,
  DataSourceType.QuoraAds,
  DataSourceType.Podio,
  DataSourceType.Greenhouse,
  DataSourceType.Gusto,
  DataSourceType.Intercom,
  DataSourceType.Etsy,
  DataSourceType.PinterestAds,
  DataSourceType.ActiveCampaign,
  DataSourceType.Basecamp,
  DataSourceType.Jotform,
  DataSourceType.Zohobooks,
  DataSourceType.Coda,
  DataSourceType.Square,
  DataSourceType.Zoom,
  DataSourceType.Webflow,
  DataSourceType.ZohoCrm,
  DataSourceType.Bigin,
  DataSourceType.Lever,
  DataSourceType.Salesloft,
  DataSourceType.Wordpress,
  DataSourceType.WooCommerce,
  DataSourceType.Bigcommerce,
  DataSourceType.Smartlead,
  DataSourceType.Affinity,
  DataSourceType.Amplitude,
  DataSourceType.Shiprocket,
  DataSourceType.Databricks,
  DataSourceType.Rippling,
  DataSourceType.Apollo,
  DataSourceType.AwsBilling,
  DataSourceType.Sage,
  DataSourceType.GoogleClassroom,
  DataSourceType.SharepointLists,
  ...CONFIG_DRIVEN_AI_DATA_SOURCE_TYPES,
];

export const NON_CONNECTOR_DATA_SOURCE_TYPES: Array<DataSourceType> = [
  DataSourceType.GptCopilot,
  DataSourceType.GoogleDrive,
  DataSourceType.OneDrive,
];

export const DATA_SOURCES_WITH_MULTIPLE_CONNECT_MODES: Array<DataSourceType> = [
  DataSourceType.Bigquery,
  DataSourceType.Snowflake,
  DataSourceType.Looker,
];

export const DATA_SOURCES_USE_SECONDARY_SQL_CONNECTION_FORM: Array<DataSourceType> = [
  DataSourceType.Mongodb,
  DataSourceType.Databricks,
];

export enum AuthType {
  PPRESS = "PPRESS",
  OAUTH = "OAUTH",
  API_KEY = "API_KEY",
  SQL = "SQL",
  AMPLITUDE = "AMPLITUDE",
  TABLEAU = "TABLEAU",
  LOOKER = "LOOKER",
  NONE = "NONE",
  NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
}

const staticDataSourceTypeAuthTypes: Partial<Record<DataSourceType, AuthType>> = {
  [DataSourceType.AnyApiAgent]: AuthType.NONE,
  [DataSourceType.BrowserAgent]: AuthType.NONE,
  // LOOKER
  [DataSourceType.Looker]: AuthType.LOOKER,

  // TABLEAU
  [DataSourceType.Tableau]: AuthType.TABLEAU,

  // AMPLITUDE
  [DataSourceType.Amplitude]: AuthType.AMPLITUDE,

  // OAUTH
  [DataSourceType.Csv]: AuthType.OAUTH,
  [DataSourceType.GoogleDrive]: AuthType.OAUTH,
  [DataSourceType.GoogleSheets]: AuthType.OAUTH,
  [DataSourceType.Excel]: AuthType.OAUTH,
  [DataSourceType.GoogleAnalytics]: AuthType.OAUTH,

  // SQL
  [DataSourceType.Mysql]: AuthType.SQL,
  [DataSourceType.Redshift]: AuthType.SQL,
  [DataSourceType.Postgres]: AuthType.SQL,
  [DataSourceType.AuroraPostgres]: AuthType.SQL,
  [DataSourceType.AuroraMysql]: AuthType.SQL,
  [DataSourceType.CloudSqlPostgres]: AuthType.SQL,
  [DataSourceType.CloudSqlMysql]: AuthType.SQL,
  [DataSourceType.Supabase]: AuthType.SQL,
  [DataSourceType.Neon]: AuthType.SQL,
  [DataSourceType.Timescaledb]: AuthType.SQL,
  [DataSourceType.AzurePostgres]: AuthType.SQL,
  [DataSourceType.AzureMysql]: AuthType.SQL,
  [DataSourceType.AzureSql]: AuthType.SQL,
  [DataSourceType.Clickhouse]: AuthType.SQL,
  [DataSourceType.Mssql]: AuthType.SQL,
  [DataSourceType.Bigquery]: AuthType.SQL,
  [DataSourceType.Databricks]: AuthType.SQL,
  [DataSourceType.Motherduck]: AuthType.SQL,

  // PPRESS
  [DataSourceType.Jira]: AuthType.PPRESS,
  [DataSourceType.InstagramInsights]: AuthType.PPRESS,
  [DataSourceType.Stripe]: AuthType.PPRESS,
  [DataSourceType.Zendesk]: AuthType.PPRESS,
  [DataSourceType.Hubspot]: AuthType.PPRESS,
  [DataSourceType.Quickbooks]: AuthType.PPRESS,
  [DataSourceType.Shopify]: AuthType.PPRESS,
  [DataSourceType.GoogleAds]: AuthType.PPRESS,
  [DataSourceType.GoogleAnalytics4]: AuthType.PPRESS,
  [DataSourceType.FacebookAds]: AuthType.PPRESS,
  [DataSourceType.FacebookInsights]: AuthType.PPRESS,
  [DataSourceType.Mongodb]: AuthType.PPRESS,
  [DataSourceType.NetflixQuiver]: AuthType.PPRESS,
  [DataSourceType.Snowflake]: AuthType.PPRESS,
  [DataSourceType.Salesforce]: AuthType.PPRESS,
  [DataSourceType.Airtable]: AuthType.PPRESS,
  [DataSourceType.Mailchimp]: AuthType.PPRESS,
  [DataSourceType.Pipedrive]: AuthType.PPRESS,
  [DataSourceType.OneDrive]: AuthType.PPRESS,
  [DataSourceType.SharepointLists]: AuthType.PPRESS,
  [DataSourceType.Box]: AuthType.OAUTH,
  [DataSourceType.Egnyte]: AuthType.PPRESS,
  [DataSourceType.Outreach]: AuthType.PPRESS,
  [DataSourceType.GoogleSearchConsole]: AuthType.PPRESS,
  [DataSourceType.Chargebee]: AuthType.PPRESS,
  [DataSourceType.Notion]: AuthType.PPRESS,
  [DataSourceType.LinkedinAds]: AuthType.PPRESS,
  [DataSourceType.LinkedinPages]: AuthType.PPRESS,
  [DataSourceType.YoutubeAnalytics]: AuthType.PPRESS,
  [DataSourceType.MicrosoftAds]: AuthType.PPRESS,
  [DataSourceType.Netsuite]: AuthType.PPRESS,
  [DataSourceType.Xero]: AuthType.PPRESS,
  [DataSourceType.Klaviyo]: AuthType.PPRESS,
  [DataSourceType.Asana]: AuthType.PPRESS,
  [DataSourceType.Razorpay]: AuthType.PPRESS,
  [DataSourceType.Clickup]: AuthType.PPRESS,
  [DataSourceType.Typeform]: AuthType.PPRESS,
  [DataSourceType.Harvest]: AuthType.PPRESS,
  [DataSourceType.Freshdesk]: AuthType.PPRESS,
  [DataSourceType.Paymo]: AuthType.PPRESS,
  [DataSourceType.GoogleCalendar]: AuthType.PPRESS,
  [DataSourceType.AmazonSellerCentral]: AuthType.PPRESS,
  [DataSourceType.Trello]: AuthType.PPRESS,
  [DataSourceType.Gong]: AuthType.PPRESS,
  [DataSourceType.Calendly]: AuthType.PPRESS,
  [DataSourceType.Smartsheet]: AuthType.PPRESS,
  [DataSourceType.RedditAds]: AuthType.PPRESS,
  [DataSourceType.Surveymonkey]: AuthType.PPRESS,
  [DataSourceType.QuoraAds]: AuthType.PPRESS,
  [DataSourceType.Podio]: AuthType.PPRESS,
  [DataSourceType.Greenhouse]: AuthType.PPRESS,
  [DataSourceType.Gusto]: AuthType.PPRESS,
  [DataSourceType.Intercom]: AuthType.PPRESS,
  [DataSourceType.Etsy]: AuthType.PPRESS,
  [DataSourceType.PinterestAds]: AuthType.PPRESS,
  [DataSourceType.ActiveCampaign]: AuthType.PPRESS,
  [DataSourceType.Basecamp]: AuthType.PPRESS,
  [DataSourceType.Jotform]: AuthType.PPRESS,
  [DataSourceType.Zohobooks]: AuthType.PPRESS,
  [DataSourceType.Coda]: AuthType.PPRESS,
  [DataSourceType.Square]: AuthType.PPRESS,
  [DataSourceType.Zoom]: AuthType.PPRESS,
  [DataSourceType.Webflow]: AuthType.PPRESS,
  [DataSourceType.ZohoCrm]: AuthType.PPRESS,
  [DataSourceType.Bigin]: AuthType.PPRESS,
  [DataSourceType.Lever]: AuthType.PPRESS,
  [DataSourceType.Salesloft]: AuthType.PPRESS,
  [DataSourceType.Wordpress]: AuthType.PPRESS,
  [DataSourceType.WooCommerce]: AuthType.PPRESS,
  [DataSourceType.Bigcommerce]: AuthType.PPRESS,
  [DataSourceType.Smartlead]: AuthType.PPRESS,
  [DataSourceType.Affinity]: AuthType.PPRESS,
  [DataSourceType.Shiprocket]: AuthType.PPRESS,
  [DataSourceType.Rippling]: AuthType.PPRESS,
  [DataSourceType.Apollo]: AuthType.PPRESS,
  [DataSourceType.AwsBilling]: AuthType.PPRESS,
  [DataSourceType.Gmail]: AuthType.PPRESS,
  [DataSourceType.Sage]: AuthType.PPRESS,
  [DataSourceType.GoogleClassroom]: AuthType.PPRESS,

  // NONE
  [DataSourceType.GptCopilot]: AuthType.NONE,
  [DataSourceType.CloudTable]: AuthType.NONE,
  [DataSourceType.CustomApi]: AuthType.NONE,
  [DataSourceType.NetsuiteCrx]: AuthType.NONE,

  // NOT IMPLEMENTED
  [DataSourceType.Chargify]: AuthType.NOT_IMPLEMENTED,
  [DataSourceType.Marketo]: AuthType.NOT_IMPLEMENTED,
  [DataSourceType.Sendgrid]: AuthType.NOT_IMPLEMENTED,
  [DataSourceType.WebScraper]: AuthType.NOT_IMPLEMENTED,
};

export const DATA_SOURCE_AUTH_TYPE: Record<DataSourceType, AuthType> = {
  ...staticDataSourceTypeAuthTypes,
  ...Object.fromEntries(
    CONFIG_DRIVEN_AI_DATA_SOURCE_TYPES.map(dataSourceType => [dataSourceType, AuthType.PPRESS])
  ),
} as Record<DataSourceType, AuthType>;

export const DISABLED_PREVIEW_PPRESS_DATASOURCES: Array<DataSourceType> = [
  DataSourceType.Quickbooks,
  DataSourceType.Xero,
  DataSourceType.Shopify,
  DataSourceType.GoogleAnalytics4,
  DataSourceType.NetsuiteCrx,
  DataSourceType.AnyApiAgent,
  DataSourceType.BrowserAgent,
  DataSourceType.Linkedin,
  ...CONFIG_DRIVEN_AI_DATA_SOURCE_TYPES,
];

export const CONNECTORS_SKIP_SUBOPTIONS_ENABLED: Array<DataSourceType> = [
  DataSourceType.GoogleAnalytics,
  // DataSourceType.Airtable,
  DataSourceType.GoogleSearchConsole,
  DataSourceType.Gmail,
  DataSourceType.FacebookInsights,
  DataSourceType.Chargebee,
  DataSourceType.Notion,
  DataSourceType.YoutubeAnalytics,
  DataSourceType.LinkedinAds,
  DataSourceType.LinkedinPages,
  DataSourceType.AwsBilling,
];

export const COLORS = {
  // NEUTRALS
  black: "#000000",
  black2: "#FAFAFA",
  black4: "#F5F5F5",
  black5: "#F9F9F9",
  black6: "#EFEFEF",
  black9: "#E8E8E8",
  black10: "#EEEEEE",
  black15: "#D9D9D9",
  black20: "#CECECE",
  black25: "#BFBFBF",
  black30: "#B0B0B0",
  black35: "#979797",
  black45: "#868686",
  black50: "#727272",
  black60: "#5f5f5f",
  black65: "#595959",
  black70: "#454545",
  black85: "#262626",
  black93: "#111215",
  white: "#FFFFFF",

  // PRIMARIES
  coeblue: "#E6F3FF",
  coeblue1: "#A3D1FF",
  coeblue2: "#7AB8FF",
  coeblue3: "#529DFF",
  coeblue4: "#3053FF",
  coeblue5: "#0054E6",
  coeblue6: "#0040BF",
  coeblue7: "#002E99",
  coeblue75: "#0026E2",
  coeblue8: "#001F73",
  coeblue9: "#00124D",
  coeblue10: "#F8FAFF",
  coeblue11: "#EFF4FE",
  coeblue12: "#DEE9FE",

  // SECONDARIES
  lightBlue: "#7DBCFF",
  blue: "#D9E6FB",
  cyan: "#13C2C2",
  cyan2: "#ADE7FF",
  gold: "#FAAD14",
  gray: "#8C8C8C",
  green: "#52C41A",
  green2: "#0F9D58",
  green3: "#00a300",
  lime: "#A0D911",
  magenta: "#EB2F96",
  orange: "#FA8C16",
  orange2: "#F8B000",
  purple: "#722ED1",
  red: "#F5222D",
  red2: "#FA1616",
  red3: "#FDD",
  red4: "#DE1135",
  volcano: "#FA541C",
  teal: "#13C2C2",
  yellow: "#FAC82A",
  yellow2: "#f8b000",
  yellowLight: "#FFE07D",
  lightGreenBg: "#DBF6F0",
  greenBg: "#D3F2F3",
  greenBg2: "#D7F5E7",
  scheduleBg: "#E2F8FB",
  redBg: "#FEE3E5",
  redBg2: "#FFE1DE",
  orangeBg: "#FDF2DC",
  orangeBg2: "#FFF3DC",
  orangeBg3: "#FEEDCB",
  orangeBg4: "#FDF2DC",
  purpleBg: "#F1E8FF",
  purpleBg2: "#E4D5FD",
  purpleBg3: "#D1BAF3",
  seafoamBg: "#E0F6F6",
  seafoam: "#08979C",
  yellowBg: "#FFF2D8",
  yellowBg2: "#FBE5B6",
  aeroBlue: "#D3F6E5",
  magnolia: "#F5E9FF",
  water: "#DBF5F5",
  silk: "#FFF7DF",
  magentaBg: "#FEEFF9",

  // SPECIAL
  parameters: "#77B2FF",

  // GPT
  editorPurpleBg: "#142163",
  buttonPurpleBg: "#293886",
  buttonPurpleBgHover: "#3E4FA6",
  purpleText: "#F35DF6",
  purpleText2: "#D13AD6",
  purpleDark: "#8320C0",
};

export const SHADOWS = {
  // Translucent so it doesn't read as a glow over DisabledOverlay.dark (ENG-8404)
  slideUpPanel: "0px -8px 16px rgba(96, 96, 96, 0.1), 0px -32px 40px rgba(96, 96, 96, 0.1)",
};

export const OVERLAYS = {
  dim: "#DDDDDD",
  dimOpacity: 0.65,
};

export const DB_DEFAULT_PORTS: Partial<Record<DataSourceType, number>> = {
  [DataSourceType.Mysql]: 3306,
  [DataSourceType.Postgres]: 5432,
  [DataSourceType.AuroraPostgres]: 5432,
  [DataSourceType.CloudSqlPostgres]: 5432,
  [DataSourceType.AuroraMysql]: 3306,
  [DataSourceType.CloudSqlMysql]: 3306,
  [DataSourceType.Supabase]: 5432,
  [DataSourceType.Neon]: 5432,
  [DataSourceType.Timescaledb]: 5432,
  [DataSourceType.AzurePostgres]: 5432,
  [DataSourceType.AzureMysql]: 3306,
  [DataSourceType.AzureSql]: 1433,
  [DataSourceType.Clickhouse]: 8443,
  [DataSourceType.Redshift]: 5439,
  [DataSourceType.Snowflake]: 443,
  [DataSourceType.Mssql]: 1433,
  [DataSourceType.ArrowFlightSql]: 443,
};

export const ERROR_TITLES = {
  GENERIC_ERROR: "Uh-oh. Something went wrong.",
};

export const ERROR_MESSAGES = {
  GENERIC_ERROR: "If the issue persists, please send us a message at help@coefficient.io",
};

export const WARNING_TITLES = {
  POPUP_BLOCKED: "Pop-up blocked",
  GENERIC_WARNING: "Uh-oh. Something went wrong.",
};

export const WARNING_MESSAGES = {
  GENERIC_WARNING: "",
  POPUP_BLOCKED: "Please allow pop-ups for this site and try again.",
};

export const LEAD_FORM_URL = "https://coefficient837626.typeform.com/to/YUlLtu";

export const HEIGHT = {
  xxs: "16px",
  xs: "20px",
  sm: "24px",
  md: "32px",
  lg: "40px",
};

export const TEXT_SIZE = {
  lg: "16px",
  md: "14px",
  sm: "12px",
};

export const LOGO_SIZE = {
  width: "120px",
};

export const PIVOT_SORT_TYPES: SortType[] = ["asc", "desc"];

export const SORT_TYPES: Array<{
  dataKey: string;
  label: string;
}> = [
  { dataKey: "asc", label: "↑ ASC" },
  { dataKey: "desc", label: "↓ DESC" },
];

export const HOURLY = [
  { label: "Every hour", value: 1 },
  { label: "Every 2 hours", value: 2 },
  { label: "Every 4 hours", value: 4 },
  { label: "Every 8 hours", value: 8 },
];

export const WEEKDAYS = [
  { dataKey: 0, label: "Sunday", shortLabel: "Sun" },
  { dataKey: 1, label: "Monday", shortLabel: "Mon" },
  { dataKey: 2, label: "Tuesday", shortLabel: "Tue" },
  { dataKey: 3, label: "Wednesday", shortLabel: "Wed" },
  { dataKey: 4, label: "Thursday", shortLabel: "Thu" },
  { dataKey: 5, label: "Friday", shortLabel: "Fri" },
  { dataKey: 6, label: "Saturday", shortLabel: "Sat" },
];

export const MONTHLY = [{ label: "Last Day", value: 31 }];

export const PIVOT_AGGREGATION: PivotValueAggregationType[] = [
  "count",
  "sum",
  "countunique",
  "average",
  "max",
  "min",
];

export const BUCKETING_TYPE: PivotDimensionBucketingType[] = ["day", "month", "quarter", "year"];

export const BASE_PLAN: SubscriptionPlanType[] = [
  SubscriptionPlanType.Starter,
  SubscriptionPlanType.LifetimeFree,
  SubscriptionPlanType.Plus,
  SubscriptionPlanType.NewUser,
];

export const SUB_AND_GRAND_TOTALS_SUPPORTED_AGGREGATION_TYPES = ["sum", "count", "min", "max"];
